export const defaultSidebarMenuConfig = [
    {
        // label: "Platform",
        items: [
            {
                menuKey: "dashboard",
                menuTitle: "Dashboard",
                menuIcon: "lucide:layout-dashboard",
                navigationPath: "/dashboard",
            }
        ],
    },
    {
        label: "Management",
        items: [
            // {
            //     menuKey: "skillManagement",
            //     menuTitle: "Skill Management",
            //     menuIcon: "tabler:bulb",
            //     navigationPath: "/skillManagement",
            // },
            {
                menuKey: "skillMaster",
                menuTitle: "Skill Master",
                menuIcon: "mdi:puzzle-edit-outline",
                navigationPath: "/skill-master",
            },
            {
                menuKey: "jobOrientedSkill",
                menuTitle: "Job-Oriented Skill Master",
                menuIcon: "mdi:briefcase-edit-outline",
                navigationPath: "/job-oriented-skill",
            },
            {
                menuKey: "skillAchievements",
                menuTitle: "Skill Achievements",
                menuIcon: "mdi:achievement-award",
                navigationPath: "/skill-achievements",
            },
            {
                menuKey: "academicRecords",
                menuTitle: "Academic Records",
                menuIcon: "mdi:academic-cap-outline",
                navigationPath: "/academic-records",
            },
            {
                menuKey: "studentAnnouncements",
                menuTitle: "Announcements",
                menuIcon: "mdi:announcement-outline",
                navigationPath: "/student-announcements",
            },
            {
                menuKey: "studentAchievements",
                menuTitle: "Student Achievements",
                menuIcon: "mdi:achievement-award",
                navigationPath: "/student-achievements",
            }
        ],
    }
];
